import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import {ReportsLayout} from './reportsLayout';

export default {
  list: ReportsLayout,
  icon: LocalOfferIcon,
};
